import React from 'react';
import { StyleSheet } from 'react-native';

import BillAutoDebitDetails from 'shared/modules/bill/components/organisms/BillAutoDebitDetails';
import Dialog from 'shared/modules/common/components/atoms/Dialog';

type Props = {
  billId: string;
  open: boolean;
  onOpen?: () => void;
  onCloseButtonPress?: () => void;
  onClose?: () => void;
};

const BillAutoDebitDetailsDialog = (props: Props) => {
  return (
    <Dialog
      title="口座振替について"
      open={props.open}
      onOpen={props.onOpen}
      onCloseButtonPress={props.onCloseButtonPress}
      onClose={props.onClose}
      id="bill-autodebit-detail-dialog"
    >
      <BillAutoDebitDetails
        billId={props.billId}
        style={style.billAutoDebitDetails}
      />
    </Dialog>
  );
};

const style = StyleSheet.create({
  billAutoDebitDetails: {
    marginHorizontal: -24,
    marginBottom: -24,
    paddingTop: 0,
  },
});

export default BillAutoDebitDetailsDialog;
